/**
 * CL-SCHEDULE-001B — Schedule permission editor (pure).
 */

import { CLIENT_PORTAL_MODULE_PERMISSION_KEYS } from "./clientPortalModulePermissionKeys";

export const SCHEDULE_EDIT_PERMISSION_KEY = "canEditSchedule";

export const SCHEDULE_PERMISSION_CONTROL_KEYS = Object.freeze([
  CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule,
  SCHEDULE_EDIT_PERMISSION_KEY,
]);

export const SCHEDULE_PERMISSION_CONTROL_LABELS = Object.freeze({
  [CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule]: "View schedule",
  [SCHEDULE_EDIT_PERMISSION_KEY]: "Edit schedule",
});

export const SCHEDULE_PERMISSION_EXPLANATIONS = Object.freeze({
  [CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule]:
    "View the project schedule, milestones and progress.",
  [SCHEDULE_EDIT_PERMISSION_KEY]:
    "Create, edit, delete and reschedule project tasks. Non-client collaborators only.",
});

function clonePermissions(permissions = {}) {
  return { ...(permissions || {}) };
}

function isClientRole(role = "") {
  return String(role ?? "").trim().toLowerCase() === "client";
}

export function listProjectSchedulePermissionControls({ role = "" } = {}) {
  if (isClientRole(role)) return [];
  return [
    {
      key: CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule,
      label: SCHEDULE_PERMISSION_CONTROL_LABELS[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule],
    },
    {
      key: SCHEDULE_EDIT_PERMISSION_KEY,
      label: SCHEDULE_PERMISSION_CONTROL_LABELS[SCHEDULE_EDIT_PERMISSION_KEY],
    },
  ];
}

export function shouldShowSchedulePermissionsSection({ role = "" } = {}) {
  return !isClientRole(role);
}

export function applySchedulePermissionToggle(permissions = {}, key = "", checked = false) {
  const next = clonePermissions(permissions);
  if (key === SCHEDULE_EDIT_PERMISSION_KEY) {
    next[SCHEDULE_EDIT_PERMISSION_KEY] = checked === true;
    if (checked === true) {
      next[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule] = true;
    }
    return next;
  }
  if (key === CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule) {
    next[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule] = checked === true;
    if (checked !== true) {
      next[SCHEDULE_EDIT_PERMISSION_KEY] = false;
    }
    return next;
  }
  return next;
}

export function applyDeliberateSchedulePermissionEdit({ permissions = {}, key = "", checked = false } = {}) {
  return applySchedulePermissionToggle(permissions, key, checked);
}

export function isSchedulePermissionControlChecked(key, permissions = {}) {
  return permissions?.[key] === true;
}

export function normalizeSchedulePermissionsForAssignmentSave(
  permissions = {},
  { rawPermissions = null, role = "" } = {}
) {
  const source = rawPermissions && typeof rawPermissions === "object" ? rawPermissions : permissions;
  const next = clonePermissions(permissions);
  if (typeof source?.[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule] === "boolean") {
    next[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule] =
      source[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule] === true;
  }
  if (isClientRole(role)) {
    delete next[SCHEDULE_EDIT_PERMISSION_KEY];
    return next;
  }
  if (typeof source?.[SCHEDULE_EDIT_PERMISSION_KEY] === "boolean") {
    next[SCHEDULE_EDIT_PERMISSION_KEY] = source[SCHEDULE_EDIT_PERMISSION_KEY] === true;
    if (next[SCHEDULE_EDIT_PERMISSION_KEY] === true) {
      next[CLIENT_PORTAL_MODULE_PERMISSION_KEYS.schedule] = true;
    }
  } else {
    delete next[SCHEDULE_EDIT_PERMISSION_KEY];
  }
  return next;
}
